const DEFAULT_OPTIONS = {
  maxSide: 1600,
  minSide: 480,
  initialQuality: 0.85,
  minQuality: 0.4,
  maxBase64Length: 500000,
};

const IMAGE_EXTENSION_PATTERN = /\.(png|jpe?g|gif|bmp|webp|tiff?|heic|heif|avif)$/i;

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Gagal memuat gambar'));
    };
    img.src = url;
  });

const drawToDataUrl = (img, width, height, quality) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  canvas.width = width;
  canvas.height = height;
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(img, 0, 0, width, height);

  return canvas.toDataURL('image/jpeg', quality);
};

export const compressImageToDataUrl = (file, options = {}) => {
  const config = { ...DEFAULT_OPTIONS, ...options };

  return loadImage(file).then((img) => {
    const rawSide = Math.max(img.naturalWidth, img.naturalHeight) || 1;
    const scale = Math.min(1, config.maxSide / rawSide);
    let width = Math.max(1, Math.round(img.naturalWidth * scale));
    let height = Math.max(1, Math.round(img.naturalHeight * scale));
    let quality = config.initialQuality;

    let dataUrl = drawToDataUrl(img, width, height, quality);

    while (dataUrl.length > config.maxBase64Length) {
      if (quality > config.minQuality) {
        quality = Math.max(config.minQuality, quality - 0.15);
      } else {
        const currentSide = Math.max(width, height);
        const nextSide = Math.max(config.minSide, Math.round(currentSide * 0.75));

        if (nextSide >= currentSide) {
          break;
        }

        const nextScale = nextSide / currentSide;
        width = Math.max(1, Math.round(width * nextScale));
        height = Math.max(1, Math.round(height * nextScale));
      }

      dataUrl = drawToDataUrl(img, width, height, quality);
    }

    const name = file && file.name
      ? String(file.name).replace(IMAGE_EXTENSION_PATTERN, '.jpg')
      : 'pengumuman.jpg';

    return { dataUrl, name };
  });
};

export default compressImageToDataUrl;
